<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.5245 18.3933C22.1702 18.8717 21.7753 19.326 21.3457 19.7485C20.9102 20.1654 20.4373 20.5439 19.9423 20.8857C19.4458 21.2257 18.9277 21.5315 18.3869 21.7858C17.8434 22.0341 17.2841 22.2395 16.7118 22.4028C16.5509 22.4466 16.7485 23.1627 16.926 23.1145C17.5396 22.9396 18.139 22.7192 18.721 22.4528C19.3 22.1807 19.8551 21.8534 20.3862 21.4897C20.9158 21.1242 21.4213 20.7192 21.8866 20.2733C22.3459 19.8222 22.7686 19.3364 23.1475 18.8243C23.2564 18.6774 22.6239 18.259 22.5245 18.3933Z"
				:fill="color"
			/>
			<path
				d="M19.0979 15.1531C18.5385 16.1524 17.6144 17.0394 16.5805 17.5749C15.5483 18.1161 14.4286 18.3417 13.142 18.2527C12.8027 18.2255 12.4761 18.1914 12.166 18.1054C12.0738 18.0913 11.8763 18.8077 11.9848 18.8257C14.6843 19.4576 17.4407 18.5247 19.1467 16.4136C19.3755 16.1236 19.5959 15.8274 19.7689 15.5104C19.8228 15.4162 19.1439 15.0729 19.0979 15.1531Z"
				:fill="color"
			/>
			<path
				d="M8.22609 15.1799C7.65719 14.1802 7.4056 13.1148 7.4763 11.8656C7.55276 10.6975 7.94377 9.66344 8.668 8.71637C8.87491 8.45918 9.10048 8.21319 9.34194 7.98237C9.41373 7.9181 8.89229 7.375 8.8085 7.45049C7.82584 8.37345 7.15769 9.53456 6.87388 10.7499C6.82104 10.8994 6.81932 11.0618 6.77355 11.215C6.77183 11.3781 6.71555 11.5313 6.72221 11.6993C6.67645 12.0234 6.70181 12.3759 6.70695 12.7083C6.72176 13.0414 6.78537 13.3554 6.83198 13.6696C6.91213 13.9756 6.99138 14.2788 7.09795 14.5753C7.22859 14.9036 7.3807 15.2257 7.55687 15.5406C7.61529 15.6328 8.27615 15.2583 8.22609 15.1799Z"
				:fill="color"
			/>
			<path
				d="M5.6673 5.11801C7.10308 3.61655 8.96788 2.54867 10.9508 2.06251C11.4512 1.9475 11.9599 1.8604 12.4792 1.79927C13.0006 1.76806 13.5388 1.71652 14.0741 1.75273C14.6061 1.77765 15.1295 1.81507 15.6354 1.91758C15.8941 1.94468 16.1373 2.02993 16.3923 2.06896C16.6344 2.153 16.8898 2.19349 17.1279 2.28914C17.6723 2.46616 18.2091 2.67448 18.7177 2.94643C18.8704 3.01628 19.2429 2.36841 19.0754 2.29083C17.1165 1.29053 14.9036 0.844936 12.6008 1.04825C10.3731 1.23915 8.2761 2.03799 6.49701 3.38081C6.00288 3.75487 5.52659 4.15949 5.10573 4.61379C4.97315 4.74291 5.5455 5.23544 5.6673 5.11801Z"
				:fill="color"
			/>
			<path
				d="M14.2669 22.8089C13.0133 22.8565 11.7873 22.7485 10.6473 22.4172C10.0743 22.2567 9.51081 22.0615 8.96899 21.8092C8.42952 21.5533 7.90727 21.2557 7.40904 20.9183C7.27004 20.8226 6.81588 21.4194 6.96842 21.5246C7.50142 21.8857 8.06042 22.2043 8.63879 22.478C9.21905 22.7481 9.82275 22.958 10.437 23.13C11.6597 23.4841 12.9714 23.6013 14.3084 23.5494C14.4957 23.5309 14.4381 22.7915 14.2669 22.8089Z"
				:fill="color"
			/>
			<path
				d="M3.30366 15.5823C3.11974 15.0328 2.97991 14.4705 2.88173 13.8943C2.79557 13.3172 2.76207 12.7188 2.76614 12.1141C2.76419 11.5076 2.83423 10.9224 2.94507 10.3509C3.05575 9.77971 3.20418 9.21976 3.40659 8.67537C3.47016 8.52553 2.75647 8.25648 2.68684 8.42197C2.46989 9.00523 2.31003 9.60543 2.19164 10.2174C2.07328 10.8297 1.99916 11.4558 2.00043 12.1028C1.99552 12.7479 2.03204 13.387 2.12442 14.0052C2.22881 14.6221 2.37878 15.2249 2.5762 15.8139C2.63616 15.9823 3.35845 15.7356 3.30366 15.5823Z"
				:fill="color"
			/>
			<path
				d="M14.2507 6.31625C14.9457 6.38706 15.5871 6.53392 16.1989 6.81612C16.5054 6.95161 16.8064 7.1096 17.0969 7.29348C17.3816 7.4864 17.6547 7.70181 17.9103 7.93634C17.9818 8.00062 18.5213 7.47438 18.4377 7.39889C18.1513 7.1363 17.8453 6.89507 17.5255 6.67901C17.1996 6.47214 16.8613 6.29399 16.5158 6.14108C15.8261 5.82469 15.1002 5.65645 14.3206 5.5779C14.2058 5.57306 14.1522 6.3127 14.2507 6.31625Z"
				:fill="color"
			/>
			<path
				d="M5.55543 19.3334C5.00609 18.734 4.52486 18.0811 4.12376 17.3928C4.03545 17.2532 3.35806 17.5995 3.45473 17.7538C3.88399 18.4906 4.39895 19.1893 4.98653 19.8298C5.11417 19.9632 5.6721 19.4555 5.55543 19.3334Z"
				:fill="color"
			/>
			<path
				d="M10.8576 6.93194C11.2682 6.73362 11.6852 6.56183 12.1278 6.46594C12.2195 6.45038 12.0503 5.72743 11.9419 5.74679C11.4431 5.85631 10.9713 6.04801 10.5092 6.27174C10.41 6.3194 10.7731 6.9721 10.8576 6.93194Z"
				:fill="color"
			/>
			<path
				d="M10.892 17.6515C10.4834 17.4496 10.0859 17.2049 9.71619 16.9154C9.64657 16.8487 9.14556 17.4095 9.22785 17.4866C9.64184 17.8114 10.0879 18.0867 10.5481 18.3139C10.6445 18.367 10.9738 17.6974 10.892 17.6515Z"
				:fill="color"
			/>
			<path
				d="M8.16187 21.1547C8.16187 21.6427 7.75325 22.0383 7.249 22.0383C6.74478 22.0383 6.33594 21.6427 6.33594 21.1547C6.33594 20.6668 6.74478 20.2713 7.249 20.2713C7.75325 20.2713 8.16187 20.6668 8.16187 21.1547Z"
				:fill="color"
			/>
			<path
				d="M15.572 23.1166C15.572 23.6046 15.1631 24 14.6592 24C14.1549 24 13.7461 23.6046 13.7461 23.1166C13.7461 22.6288 14.1549 22.2329 14.6592 22.2329C15.1631 22.2329 15.572 22.6288 15.572 23.1166Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgSNMMIConnect',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
